import axios from 'axios';

function getUrl(path = '') {
  const baseURLs = {
    'local':'http://blog.localhost', 
    'io'   :'https://blog.kub.app.builderall.io',
    'info' :'https://blog.kub.app.builderall.info', 
    'com'  :'https://blog.builderall.com' 
  }
  
  let url = '';

  if(window.location.host.includes('localhost:')) {
    url = baseURLs.local
  } else {
    url = baseURLs[
      window.location.host.includes('.com') ? 'com' : (
        window.location.host.includes('.info') ? 'info' : 'io'
      )
    ]
  }

  url = url + path;

  // veririca se esta no editor pra usar a mesma função
  if (window.location.hash.indexOf('#/editor') !== -1) {
    if (url.indexOf('?') !== -1) {
      url += '&page_id=' + window.location.hash.replace('#/editor/', '');
    } else {
      url += '?page_id=' + window.location.hash.replace('#/editor/', '');
    }
  }
  return url;
}

export const getNews = ({perPage = 4, actualPage = 1, featured = false}) => {
  let path = '?perpage=' + perPage + '&page=' + actualPage;
  if (featured) { path += '&featured=yes' }
  return axios.get(getUrl('/get-news' + path));
};

// CONFIG FUNCTIONS ARTICLE COMPONENT
export const getAllNews = () => axios.get(getUrl('/news/get-all'));
export const getCategories = () => axios.get(getUrl(`/categories/get`));
export const getAuthors = () => axios.get(getUrl(`/authors/get`));

export const getFilteredNews = (config) => {

  if (config.type === 'featured' && config.selectedArticle !== 0) { return axios.get(getUrl(`/news/get-by-id/${config.selectedArticle}`)) }

  if (config.type === 'group') {

    let path = `/news/get-filtered-news?category=${config.filters.category}&author=${config.filters.author}&featured=${config.filters.featured}&most_accessed=${config.filters.mostAccessed}&amount=${config.filters.amount}&type=group`;
    console.log(path);
    return axios.get(getUrl(path));
  }

  if (config.type === 'feed') {
    let path = `/news/get-filtered-news?category=${config.filters.category}&author=${config.filters.author}&featured=${config.filters.featured}&most_accessed=${config.filters.mostAccessed}&amount=${config.filters.amount}&type=feed`;
    return axios.get(getUrl(path));
  }

};

export const getNewByID = (id) => axios.get(getUrl(`/news/get-by-id/${id}`));

export const getAuthor = (id) => axios.get(getUrl(`/author/get/${id}`));

export const getNew = (path) => axios.get(getUrl('/get-new' + path));

export const getChilds = (path) => axios.get(getUrl('/get-childs' + path));



// WEBPACK FOOTER //
// ./src/js/services/editor/blog.js